import MaticLogo from "@assets/svg/MaticLogo";
import CartChip from "@/blueprint/components/NavPill/CartChip";
import { getDisplayCartQuantity } from "@/cart/displayCart";
import useCart from "@/cart/useCart";
import { NAV_WORDMARK_CLASSES } from "@/chrome/SiteNav/navWordmark";
import useLayoutStore from "@/stores/useLayoutStore";

/**
 * The chrome for pages reached from an ad: the wordmark and the cart, nothing
 * to wander off to. The wordmark is not a link for the same reason. The cart
 * chip is SiteNav's own, at a 44px target.
 */
const MinimalNav = () => {
  const cart = useCart((state) => state.cart);
  const openSideCart = useLayoutStore((state) => state.openSideCart);

  return (
    <div className="flex items-center justify-between px-grid-margin py-s">
      <span role="img" aria-label="Matic" className="text-content-primary">
        <MaticLogo classes={NAV_WORDMARK_CLASSES} />
      </span>
      <CartChip
        count={getDisplayCartQuantity(cart)}
        onClick={() => openSideCart()}
        navControl="cart"
        className="size-11"
      />
    </div>
  );
};

export default MinimalNav;
